
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { RunSettingsHandler } from "../game/RunSettingsHandler";
/* END-USER-IMPORTS */

export default class PowerTracker extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 128.5, y ?? 55);

    // panel
    const panel = scene.add.image(0, 0, "game", "box-top.png");
    panel.scaleY = 0.833;
    this.add(panel);

    // icon_charge_png
    const icon_charge_png = scene.add.image(-72, 0, "game", "icon-charge.png");
    this.add(icon_charge_png);

    // icon_battery_png
    const icon_battery_png = scene.add.image(25, 0, "game", "icon-battery.png");
    this.add(icon_battery_png);

    // chargeBacks
    const chargeBacks = scene.add.container(-128.5, -55);
    this.add(chargeBacks);

    // charge_empty_png
    const charge_empty_png = scene.add.image(114, 55, "game", "charge-empty.png");
    chargeBacks.add(charge_empty_png);

    // charge_empty_png_1
    const charge_empty_png_1 = scene.add.image(149, 55, "game", "charge-empty.png");
    chargeBacks.add(charge_empty_png_1);

    // charge_empty_png_2
    const charge_empty_png_2 = scene.add.image(184, 55, "game", "charge-empty.png");
    chargeBacks.add(charge_empty_png_2);

    // chargesHolder
    const chargesHolder = scene.add.container(-128.5, -55);
    this.add(chargesHolder);

    // charge1
    const charge1 = scene.add.image(114, 55, "game", "charge-full.png");
    charge1.visible = false;
    chargesHolder.add(charge1);

    // charge2
    const charge2 = scene.add.image(149, 55, "game", "charge-full.png");
    charge2.visible = false;
    chargesHolder.add(charge2);

    // charge3
    const charge3 = scene.add.image(184, 55, "game", "charge-full.png");
    charge3.visible = false;
    chargesHolder.add(charge3);

    // lists
    const charges = [charge1, charge2, charge3];

    this.charges = charges;

    /* START-USER-CTR-CODE */
    this.on(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.registry.events.off(RunSettingsHandler.events.ChangeChargesCollected, this.onPowerChargeChange, this);
    });

    this.scene.registry.events.on(RunSettingsHandler.events.ChangeChargesCollected, this.onPowerChargeChange, this);
    /* END-USER-CTR-CODE */
  }

  private charges: Phaser.GameObjects.Image[];

  /* START-USER-CODE */

  protected onPowerChargeChange(parent: any, value: any, previousValue: any) {


    var num:number = 0;
    for(const charge of this.charges){
      if(num<value){
        charge.visible = true;
      }
      else{
        charge.visible = false;
      }
      num++;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
